module.exports = __webpack_public_path__ + "static/media/ico-instagram-hover.65cf4034.svg";